import React, { Fragment } from 'react';
import { arrayOf, object, bool, func } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';
import { PointOfSaleContext } from '@olxbr/mojo-jojo/contexts';

import Logo from '../../core/components/navbar/logo.svg';
import NavItem from './NavItem';
import BackButton from '../../choices/components/BackButtonContainer';
import OrangeButton from '../../core/components/OrangeButton';

const Nav = styled.nav`
  background-color: #fff;
  ${({ sticky }) => (sticky ? 'position: sticky;' : '')}
  top: 0px;
  width: 100%;
  height: 80px;
  z-index: 1010;
  ${({ sticky }) => (sticky ? 'box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.15);' : '')}
`;

const NavContent = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: ${({ subscription }) => (subscription ? 'space-between' : 'center')};
  align-items: center;
  height: 100%;
  padding: 0px 10px;

  @media (min-width: 1000px) {
    width: 950px;
    justify-content: ${({ right }) => (right ? 'space-between' : 'flex-start')};
  }
`;

const NavLogo = styled.img`
  height: 48px;
  width: 48px;

  &:hover {
    cursor: pointer;
  }
`;

const NavMenu = styled.ul`
  display: inline-block;
`;

const NavItems = styled.ul`
  display: none;

  @media(min-width: 1000px) {
    display: inline-block;
  }
`;

const NavButton = styled(OrangeButton)`
  display: inline;
  padding: 8px 16px;
  font-size: 14px;
  margin-left: 32px;
`;

const Navbar = ({
  items, right, sticky, handleClick,
}) => (
  <PointOfSaleContext>
    {({
        posData,
      }) => (
        <Fragment>
          <Nav sticky={sticky}>
            <NavContent right={right} subscription={posData.standAlone}>
              <BackButton
                color="#6e0ad6"
                text="Voltar"
                position="absolute"
                top={30}
                left={5}
                onlyMobile
              />
              <a href="https://www.olx.com.br">
                <NavLogo onClick={() => handleClick('logo')} src={Logo} alt="Logo OLX" />
              </a>
              <NavMenu>
                <NavItems>
                  {items.map(item => (
                    <NavItem
                      key={shortid.generate()}
                      link={item.link}
                      text={item.text}
                      smooth={item.smooth}
                    />
                    ))}
                </NavItems>

                {posData.standAlone &&
                  <NavButton
                    href="https://planoprofissional.olx.com.br/"
                    type="outline"
                    onClick={() => handleClick('myplan')}
                  >
                    Já sou cliente profissional
                  </NavButton>
                }

              </NavMenu>
            </NavContent>
          </Nav>
        </Fragment>
        )}
  </PointOfSaleContext>
);

Navbar.propTypes = {
  items: arrayOf(object),
  right: bool,
  sticky: bool,
  handleClick: func.isRequired,
};

Navbar.defaultProps = {
  items: [],
  right: false,
  sticky: false,
};

export default Navbar;
